import { Router } from '@angular/router';

export abstract class BaseFormComponent {
  constructor(public router: Router) {}

  getTabNavigationDataFromUrl(): any {
    let baseUrl = this.router.url;

    // remove the eventual query string
    if (this.router.url.indexOf('?') !== -1) {
      baseUrl = this.router.url.split('?')[0];
    }

    const baseUrlSegments = baseUrl.split('/');

    const lastSegment = baseUrlSegments[baseUrlSegments.length - 1];
    let tabName = lastSegment;
    let applicantIndex = -1;

    if (!isNaN(Number(lastSegment))) {
      // if it's a number, this means we are on an applicant tab, ending for example with /applicant/0
      tabName = baseUrlSegments[baseUrlSegments.length - 2];
      applicantIndex = +lastSegment;
    }

    return {
      tab: tabName,
      index: applicantIndex
    };
  }
}
